export const useDateFormat = (val: string, locale: string = 'en-GB') => {
    const date = new Date(val);

    const formattedDate = date.toLocaleDateString(locale, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });

    return formattedDate;
};
